import Vue from 'vue'
import Vuex from 'vuex'
import brokerConfig from './modules/brokerConfig'
import quotes from './modules/quotes'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    brokerConfig,
    quotes
  }
})
